module.exports = __webpack_public_path__ + "images/ic-plus.svg";